<template>
  <v-container
    v-if="rodada"
    fluid
    class="pa-0"
    style="min-height: 100%; display: flex; flex-direction: column; justify-content: space-between;"
  >
    <div
      style="position: fixed; z-index: 1;left: 0px; width: 256px; background-color: lightgrey; height: 74px; padding: 16px 0px; font-size: x-large; font-weight: 500; text-align: center"
    >
      Showroom Rodada
    </div>

    <v-col
      cols="12"
      style="position: fixed; z-index: 1; background-color: white; width: calc(100% - 256px); left: 256px; right: 0px"
    >
      <div style="display: flex; align-items: baseline; gap: 16px">
        <v-select
          :items="fornecedores"
          label="Fornecedor"
          v-model="fornecedor"
          item-text="nome_fantasia"
          item-value="id"
          hide-details
          return-object
          placeholder="Selecione um fornecedor"
          style="width:100%"
          @change="getProdutos"
        />
        <v-btn
          depressed
          color="primary"
          @click="abrirAgendamentos"
          :disabled="!fornecedor"
        >
          Agendamento
        </v-btn>
      </div>
    </v-col>

    <v-container
      fluid
      :class="$vuetify.breakpoint.xsOnly ? 'pa-2' : 'pa-4'"
      class="pt-0"
      style="margin-top: 100px"
    >
      <v-row dense style="justify-content: center">
        <v-col
          v-for="produto in produtos.data"
          :key="produto.id"
          cols="6"
          lg="2"
          md="4"
          sm="6"
        >
          <v-hover>
            <template v-slot="{ hover }">
              <v-card
                :class="$vuetify.breakpoint.xsOnly ? 'ma-1' : 'ma-2'"
                :elevation="hover ? 18 : 2"
                :style="
                  'cursor: pointer; transition: all 0.3s ease;' +
                    (hover ? 'transform: scale(1.1); z-index: 1' : '')
                "
              >
                <v-img
                  :src="produto.fotos[0]"
                  class="white--text align-end"
                  :gradient="
                    !hover ? 'to bottom, rgba(0,0,0,0.0), rgba(0,0,0,.2)' : ''
                  "
                  @click="exibirDetalhe(produto)"
                >
                  <template v-slot:placeholder>
                    <v-row
                      class="fill-height ma-0"
                      align="center"
                      justify="center"
                    >
                      <v-progress-circular
                        indeterminate
                        color="grey lighten-5"
                      ></v-progress-circular>
                    </v-row>
                  </template>

                  <v-card-title
                    v-text="produto.descricao"
                    class="px-3 py-1"
                    :style="
                      hover
                        ? 'background-color: rgba(0,0,0,.6); font-size: 1rem; text-overflow: ellipsis; white-space: nowrap; overflow: hidden; display: block;'
                        : 'font-size: 1rem; text-overflow: ellipsis; white-space: nowrap; overflow: hidden; display: block;'
                    "
                  ></v-card-title>
                </v-img>

                <v-card-actions>
                  <v-chip
                    label
                    color="#FFD300"
                    text-color="black"
                    style="cursor: pointer"
                  >
                    <strong>R$ {{ produto.valor | valorBR }}</strong>
                  </v-chip>
                  <v-spacer></v-spacer>

                  <v-btn
                    v-if="
                      $auth.user.tipo === 'cliente' ||
                        !$auth.user.tipo | ($auth.user.tipo === 'representante')
                    "
                    icon
                    @click="exibirDetalhe(produto)"
                  >
                    <v-icon>mdi-information-outline</v-icon>
                  </v-btn>
                </v-card-actions>
              </v-card>
            </template>
          </v-hover>
        </v-col>
      </v-row>

      <div
        v-if="totalProdutos > 0"
        class="py-4"
        style="font-size: 16px; width: 100%; text-align: center"
      >
        {{ totalProdutos }} produtos encontrado{{
          totalProdutos > 1 ? "s" : ""
        }}
      </div>
      <div
        v-else
        class="py-4"
        style="font-size: 24px; height: 100px; display: flex; align-items: center; justify-content: center;"
      >
        Nenhum produto encontrado :(
      </div>

      <v-container v-if="totalProdutos > 0" fluid class="py-4">
        <v-pagination
          v-model="page"
          :length="totalPages"
          :total-visible="7"
          @input="goToPage"
        ></v-pagination>
      </v-container>
    </v-container>

    <v-container fluid :class="$vuetify.breakpoint.xsOnly ? 'pa-4' : 'pa-6'">
      <div style="font-size: 24px">Categorias</div>
      <v-row style="justify-content: center">
        <v-col
          v-for="categoria in $store.state.categorias"
          :key="categoria.id"
          cols="12"
          sm="6"
          md="4"
          lg="2"
          style="justify-content: center; display: flex"
          :class="$vuetify.breakpoint.xsOnly ? 'pa-2' : 'pa-3'"
        >
          <v-hover>
            <template v-slot="{ hover }">
              <v-chip
                class="px-3 py-2"
                x-large
                label
                :color="hover ? 'lightgrey black--text' : 'white black--text'"
                :style="
                  'cursor: pointer; width: 100%; transition: all 0.3s ease;' +
                    (hover ? 'transform: scale(1.1); z-index: 1' : '')
                "
                @click="filtrarCategoria(categoria.id)"
              >
                <img
                  :src="categoria.src"
                  style="height: 36px !important;width: 36px !important"
                />
                <span
                  class="pa-2 pl-3"
                  style="white-space: pre-wrap; overflow: hidden; text-overflow: ellipsis"
                  >{{ categoria.nome }}</span
                >
              </v-chip>
            </template>
          </v-hover>
        </v-col>
      </v-row>
    </v-container>

    <detalhe-produto :produto="produto" ref="detalheProduto" />

    <agendamentos
      ref="agendamentos"
      :fornecedores="fornecedores"
      :fornecedor="fornecedor"
      :rodadaId="rodada.id"
      @success="() => {}"
    />

    <waiting :show="overlayFiltro"></waiting>
  </v-container>

  <v-container fluid v-else>
    <v-card>
      <v-app-bar color="primary" flat dark dense>
        <v-toolbar-title>Showroom</v-toolbar-title>
        <v-spacer />
      </v-app-bar>
      <div class="ma-3">
        <v-row dense style="pointer-events: none; padding-bottom: 8px">
          <v-col cols="8">
            <span
              >Você não participa ou participou de nenhuma rodada de negócios.
              Fale com seu representante!</span
            >
          </v-col>
        </v-row>
      </div>
    </v-card>
  </v-container>
</template>

<script>
import Services from "@/services/services.js";
import DetalheProduto from "./DetalheProduto.vue";
import ServiceProdutos from "@/services/produtos.js";
import ServiceRodadas from "@/services/rodadas.js";
import Agendamentos from "../virtual/Agendamentos.vue";

export default {
  components: {
    DetalheProduto,
    Agendamentos,
  },
  name: "loja",
  data: () => ({
    page: 1,
    totalPages: 1,
    totalProdutos: 0,
    produto: {},
    produtos: [],
    showBanners: true,
    novidades: true,
    overlayFiltro: false,
    fornecedor: null,
    fornecedores: [],
    rodada: null,
    filtro: {
      termoPesquisa: "",
      categorias: [],
      filtrarValores: false,
      valorInicial: 0,
      valorFinal: 0,
      pagina: null,
      ordenacao: 0,
    },
  }),
  created() {
    this.getCategorias();
  },
  mounted() {
    this.init();
  },
  methods: {
    async init() {
      const {
        data: dataRodadas,
      } = await ServiceRodadas.carregarRodadasCliente();

      const rodadas = dataRodadas.rodadas || [];

      if (rodadas.length > 0) {
        this.rodada = dataRodadas.rodadas[dataRodadas.rodadas.length - 1];
      } else {
        this.rodada = null;
      }

      if (this.rodada) {
        const { data } = await ServiceRodadas.carregarFornecedoresRodada(
          this.rodada.id
        );
        this.fornecedores = data.fornecedores || [];
        this.fornecedor = data.fornecedores[0] || null;
        this.getProdutos();
      }
    },
    abrirAgendamentos() {
      this.$refs.agendamentos.abrir();
    },
    async buscarProdutoId(produto_id) {
      const { data: dataPro } = await ServiceProdutos.buscarPorId([produto_id]);

      this.exibirDetalhe(dataPro.produtos[0]);
    },
    goToPage(page) {
      this.filtro.pagina = page;
      this.showBanners = false;
      this.getProdutos();
    },
    filtrarCategoria(categoria) {
      this.filtro.categorias = [categoria];
      this.filtro.filtrarValores = false;
      this.filtro.valorInicial = 0;
      this.filtro.valorFinal = 0;
      this.filtro.termoPesquisa = "";
      this.filtro.ordenacao = 0;
      this.showBanners = false;
      this.novidades = false;
      this.filtro.pagina = null;
      this.$store.commit("setFiltro", { ...this.filtro });
    },
    showGrade(produto_selecionado) {
      this.produto = this.clone(produto_selecionado);
      this.$refs.grade.abrir(this.produto);
    },
    exibirDetalhe(produto_selecionado) {
      this.produto = this.clone(produto_selecionado);
      this.$refs.detalheProduto.abrir();
    },
    async getBanners() {
      let tipo = "Clientes";
      if (this.$auth.user.tipo === "fornecedor") {
        tipo = "Fornecedores";
      }
      if (this.$auth.user.tipo === "representante") {
        tipo = "Representantes";
      }
    },
    async getCategorias() {
      const { data } = await Services.categorias();
      if (data) {
        const categorias = data.categorias.map((categoria) => ({
          id: categoria.id,
          nome: categoria.nome,
          src: require(`@/assets/images/categorias/${categoria.id}.png`),
        }));
        this.$store.commit("setCategorias", categorias);
      }
    },

    async getProdutos() {
      this.overlayFiltro = true;
      const parametros = {};
      parametros.paginacao = 18;

      parametros.fornecedor = this.fornecedor ? this.fornecedor.id : "";

      if (this.filtro.pagina) {
        parametros.page = this.filtro.pagina;
      }
      if (this.filtro.categorias) {
        parametros.categorias = this.filtro.categorias.join(",");
      }
      if (this.filtro.termoPesquisa) {
        parametros.busca = this.filtro.termoPesquisa;
      }

      if (this.filtro.filtrarValores) {
        parametros.valor_minimo = this.filtro.valorInicial;
        parametros.valor_maximo = this.filtro.valorFinal;
      }

      if (this.filtro.fornecedor) {
        parametros.fornecedor = this.filtro.fornecedor;
      }

      if (this.filtro.ordenacao) {
        parametros.ordenacao = this.filtro.ordenacao;
      }

      const { data } = await ServiceProdutos.buscar(parametros);
      if (data) {
        this.produtos = data.produtos;
        this.page = data.produtos.current_page;
        this.totalPages = data.produtos.last_page;
        this.totalProdutos = data.produtos.total;
        this.overlayFiltro = false;
        window.scrollTo(0, 0);
      }
    },
  },
  watch: {
    "$store.state.filtro": {
      handler: function(filtro) {
        this.filtro.categorias = [...filtro.categorias];
        this.filtro.termoPesquisa = filtro.termoPesquisa;
        this.filtro.filtrarValores = filtro.filtrarValores;
        this.filtro.valorInicial = filtro.valorInicial;
        this.filtro.valorFinal = filtro.valorFinal;
        this.filtro.ordenacao = filtro.ordenacao;
        this.filtro.fornecedor =
          (filtro.fornecedor && filtro.fornecedor.id) || null;
        this.showBanners = false;
        this.novidades = false;
        this.getProdutos();
        this.getBanners();
      },
      deep: true,
    },
  },
};
</script>
